import * as React from 'react';

import {Relationship} from 'shells/entity/entity-display-values/relationship/relationship';

type Props = {
    name: string;
    value: string[];
};

export function CellRelationship(props: Props) {
    return <Relationship {...props} />;
}
